import { useTranslation } from 'react-i18next';
/**
 * Provides translations for the `data-import-ui` namespace using react-i18next.
 *
 * This hook ensures that components can access localized strings.
 *
 * @returns {UseTranslationResponse<'data-import-ui', undefined>} -
 * A translation response tuple including the translation function `t`,
 * the i18n instance, and the ready flag.
 */
export function useDataImportUiTranslation() {
    return useTranslation('data-import-ui');
}
